// https://tc39.github.io/ecma262/#sec-array.prototype.find
// Taken from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find#Polyfill
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function(predicate) {
     // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function(searchElement, fromIndex) {

      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      // 1. Let O be ? ToObject(this value).
      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
      }

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        if (sameValueZero(o[k], searchElement)) {
          return true;
        }
        // c. Increase k by 1.
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}
// Taken from https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
(function () {

  if ( typeof window.CustomEvent === "function" ) return false;

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();
// Taken from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
if (typeof Object.assign != 'function') {
  Object.assign = function(target, varArgs) { // .length of function is 2
    'use strict';
    if (target === null) { // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource !== null) { // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}
if (!Object.entries) {
  Object.entries = function( obj ){
    var ownProps = Object.keys( obj ),
        i = ownProps.length,
        resArray = new Array(i); // preallocate the Array
    while (i--)
      resArray[i] = [ownProps[i], obj[ownProps[i]]];

    return resArray;
  };
}
// Taken from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes#Polyfill
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.ES6Promise=e()}(this,function(){"use strict";function t(t){var e=typeof t;return null!==t&&("object"===e||"function"===e)}function e(t){return"function"==typeof t}function n(t){W=t}function r(t){z=t}function o(){return function(){return process.nextTick(a)}}function i(){return"undefined"!=typeof U?function(){U(a)}:c()}function s(){var t=0,e=new H(a),n=document.createTextNode("");return e.observe(n,{characterData:!0}),function(){n.data=t=++t%2}}function u(){var t=new MessageChannel;return t.port1.onmessage=a,function(){return t.port2.postMessage(0)}}function c(){var t=setTimeout;return function(){return t(a,1)}}function a(){for(var t=0;t<N;t+=2){var e=Q[t],n=Q[t+1];e(n),Q[t]=void 0,Q[t+1]=void 0}N=0}function f(){try{var t=Function("return this")().require("vertx");return U=t.runOnLoop||t.runOnContext,i()}catch(e){return c()}}function l(t,e){var n=this,r=new this.constructor(p);void 0===r[V]&&x(r);var o=n._state;if(o){var i=arguments[o-1];z(function(){return T(o,r,i,n._result)})}else j(n,r,t,e);return r}function h(t){var e=this;if(t&&"object"==typeof t&&t.constructor===e)return t;var n=new e(p);return w(n,t),n}function p(){}function v(){return new TypeError("You cannot resolve a promise with itself")}function d(){return new TypeError("A promises callback cannot return that same promise.")}function _(t,e,n,r){try{t.call(e,n,r)}catch(o){return o}}function y(t,e,n){z(function(t){var r=!1,o=_(n,e,function(n){r||(r=!0,e!==n?w(t,n):A(t,n))},function(e){r||(r=!0,S(t,e))},"Settle: "+(t._label||" unknown promise"));!r&&o&&(r=!0,S(t,o))},t)}function m(t,e){e._state===Z?A(t,e._result):e._state===$?S(t,e._result):j(e,void 0,function(e){return w(t,e)},function(e){return S(t,e)})}function b(t,n,r){n.constructor===t.constructor&&r===l&&n.constructor.resolve===h?m(t,n):void 0===r?A(t,n):e(r)?y(t,n,r):A(t,n)}function w(e,n){if(e===n)S(e,v());else if(t(n)){var r=void 0;try{r=n.then}catch(o){return void S(e,o)}b(e,n,r)}else A(e,n)}function g(t){t._onerror&&t._onerror(t._result),E(t)}function A(t,e){t._state===X&&(t._result=e,t._state=Z,0!==t._subscribers.length&&z(E,t))}function S(t,e){t._state===X&&(t._state=$,t._result=e,z(g,t))}function j(t,e,n,r){var o=t._subscribers,i=o.length;t._onerror=null,o[i]=e,o[i+Z]=n,o[i+$]=r,0===i&&t._state&&z(E,t)}function E(t){var e=t._subscribers,n=t._state;if(0!==e.length){for(var r=void 0,o=void 0,i=t._result,s=0;s<e.length;s+=3)r=e[s],o=e[s+n],r?T(n,r,o,i):o(i);t._subscribers.length=0}}function T(t,n,r,o){var i=e(r),s=void 0,u=void 0,c=!0;if(i){try{s=r(o)}catch(a){c=!1,u=a}if(n===s)return void S(n,d())}else s=o;n._state!==X||(i&&c?w(n,s):c===!1?S(n,u):t===Z?A(n,s):t===$&&S(n,s))}function M(t,e){try{e(function(e){w(t,e)},function(e){S(t,e)})}catch(n){S(t,n)}}function P(){return tt++}function x(t){t[V]=tt++,t._state=void 0,t._result=void 0,t._subscribers=[]}function C(){return new Error("Array Methods must be provided an Array")}function O(t){return new et(this,t).promise}function k(t){var e=this;return new e(L(t)?function(n,r){for(var o=t.length,i=0;i<o;i++)e.resolve(t[i]).then(n,r)}:function(t,e){return e(new TypeError("You must pass an array to race."))})}function F(t){var e=this,n=new e(p);return S(n,t),n}function Y(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}function q(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}function D(){var t=void 0;if("undefined"!=typeof global)t=global;else if("undefined"!=typeof self)t=self;else try{t=Function("return this")()}catch(e){throw new Error("polyfill failed because global object is unavailable in this environment")}var n=t.Promise;if(n){var r=null;try{r=Object.prototype.toString.call(n.resolve())}catch(e){}if("[object Promise]"===r&&!n.cast)return}t.Promise=nt}var K=void 0;K=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)};var L=K,N=0,U=void 0,W=void 0,z=function(t,e){Q[N]=t,Q[N+1]=e,N+=2,2===N&&(W?W(a):R())},B="undefined"!=typeof window?window:void 0,G=B||{},H=G.MutationObserver||G.WebKitMutationObserver,I="undefined"==typeof self&&"undefined"!=typeof process&&"[object process]"==={}.toString.call(process),J="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel,Q=new Array(1e3),R=void 0;R=I?o():H?s():J?u():void 0===B&&"function"==typeof require?f():c();var V=Math.random().toString(36).substring(2),X=void 0,Z=1,$=2,tt=0,et=function(){function t(t,e){this._instanceConstructor=t,this.promise=new t(p),this.promise[V]||x(this.promise),L(e)?(this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?A(this.promise,this._result):(this.length=this.length||0,this._enumerate(e),0===this._remaining&&A(this.promise,this._result))):S(this.promise,C())}return t.prototype._enumerate=function(t){for(var e=0;this._state===X&&e<t.length;e++)this._eachEntry(t[e],e)},t.prototype._eachEntry=function(t,e){var n=this._instanceConstructor,r=n.resolve;if(r===h){var o=void 0,i=void 0,s=!1;try{o=t.then}catch(u){s=!0,i=u}if(o===l&&t._state!==X)this._settledAt(t._state,e,t._result);else if("function"!=typeof o)this._remaining--,this._result[e]=t;else if(n===nt){var c=new n(p);s?S(c,i):b(c,t,o),this._willSettleAt(c,e)}else this._willSettleAt(new n(function(e){return e(t)}),e)}else this._willSettleAt(r(t),e)},t.prototype._settledAt=function(t,e,n){var r=this.promise;r._state===X&&(this._remaining--,t===$?S(r,n):this._result[e]=n),0===this._remaining&&A(r,this._result)},t.prototype._willSettleAt=function(t,e){var n=this;j(t,void 0,function(t){return n._settledAt(Z,e,t)},function(t){return n._settledAt($,e,t)})},t}(),nt=function(){function t(e){this[V]=P(),this._result=this._state=void 0,this._subscribers=[],p!==e&&("function"!=typeof e&&Y(),this instanceof t?M(this,e):q())}return t.prototype["catch"]=function(t){return this.then(null,t)},t.prototype["finally"]=function(t){var n=this,r=n.constructor;return e(t)?n.then(function(e){return r.resolve(t()).then(function(){return e})},function(e){return r.resolve(t()).then(function(){throw e})}):n.then(t,t)},t}();return nt.prototype.then=l,nt.all=O,nt.race=k,nt.resolve=h,nt.reject=F,nt._setScheduler=n,nt._setAsap=r,nt._asap=z,nt.polyfill=D,nt.Promise=nt,nt.polyfill(),nt});(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.agi = global.agi || {}));
}(this, (function (exports) { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var PlaylistLoader = /*#__PURE__*/function () {
    function PlaylistLoader() {
      _classCallCheck(this, PlaylistLoader);
    }

    _createClass(PlaylistLoader, [{
      key: "load",
      value: function load() {
        var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return fetch(url, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          body: "data=".concat(JSON.stringify(data))
        }).then(function (response) {
          return response.json();
        });
      }
    }]);

    return PlaylistLoader;
  }();

  var ProductData = /*#__PURE__*/function () {
    function ProductData(data) {
      _classCallCheck(this, ProductData);

      this.data = data || {};
      this._customizations = null;
      this._dropdowns = null;
      this._selectionData = null;
      this._groupSeparator = this.data["groupSeparator"];
      this._filters = this.data["filters"] || [];
    }

    _createClass(ProductData, [{
      key: "validateData",
      value: function validateData(data) {
        var defaultData = data || {};
        return defaultData["selectionData"] || defaultData;
      }
    }, {
      key: "customizations",
      get: function get() {
        if (this._customizations == null) {
          var selectData = this.data["selectionData"] || this.data;
          this._customizations = selectData.customizations || selectData;
        }

        return this._customizations;
      }
    }, {
      key: "choiceGroups",
      get: function get() {
        if (this._choice_groups == null) {
          this._choice_groups = this.customizations["choice-groups"] || {};
        }

        return this._choice_groups;
      }
    }, {
      key: "dropdowns",
      get: function get() {
        var _this = this;

        if (this._dropdowns == null) {
          this._dropdowns = [];
          var keys = this.customizations.keys || [];
          var labels = this.customizations.labels || {};
          keys.forEach(function (key) {
            _this._dropdowns.push({
              persName: key,
              label: labels[key],
              key: key
            });
          });
        }

        return this._dropdowns;
      }
    }, {
      key: "selectionData",
      get: function get() {
        var _this2 = this;

        if (this._selectionData == null) {
          this._selectionData = {};

          var _loop = function _loop() {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                key = _Object$entries$_i[0],
                choiceGroup = _Object$entries$_i[1];

            _this2._selectionData[key] = [];
            choiceGroup.forEach(function (group, index) {
              _this2.addSeparatorForGroup(key, index);

              group["choices"].forEach(function (choice) {
                var filtered = _this2._filters.some(function (f) {
                  return f in choice;
                });

                if (!filtered) {
                  _this2._selectionData[key].push(choice);
                }
              });
            });
          };

          for (var _i = 0, _Object$entries = Object.entries(this.choiceGroups); _i < _Object$entries.length; _i++) {
            _loop();
          }
        }

        return this._selectionData;
      }
    }, {
      key: "addSeparatorForGroup",
      value: function addSeparatorForGroup(key, index) {
        if (this._groupSeparator != null && index > 0) {
          this._selectionData[key].push({
            id: "",
            value: this._groupSeparator
          });
        }
      }
    }]);

    return ProductData;
  }();

  var DEFAULT_WIDTH = 550;
  var DEFAULT_HEIGHT = 400;

  var VideoPlayer = /*#__PURE__*/function () {
    function VideoPlayer(config) {
      _classCallCheck(this, VideoPlayer);

      this.config = config;
      this.isFullscreen = false;
      this.setupJWPlayer = false;
      this.isFullscreenOnPlayDisabled = this.config.isFullscreenOnPlayDisabled;
      this.originalWidth = this.config.width || DEFAULT_WIDTH;
      this.originalHeight = this.config.height || DEFAULT_HEIGHT;
      this.productData = new ProductData(config);
    }

    _createClass(VideoPlayer, [{
      key: "init",
      value: function init() {
        this.setupContainer();
        this.showLoader();
        this.pers = this.config.pers || {};
        this.selections = {};

        for (var key in this.config.hardcodedSelections) {
          this.selections[key] = this.config.hardcodedSelections[key];
        }

        if (this.config.mode === "init") {
          this.send();
        } else {
          this.pickup();
        }

        if (this.config.sitegroup === "bma" && this.config.maySend) {
          var sendSiteButton = document.getElementById("display-buttons-bottom");

          if (sendSiteButton !== null) {
            sendSiteButton.style.display = "none";
          }
        }

        this.wireListeners();
        this.hideLoader();
      }
    }, {
      key: "setupContainer",
      value: function setupContainer() {
        this.cardContainer = document.createElement("div");
        this.cardContainer.style.height = this.originalHeight + "px";
        this.cardContainer.style.width = this.originalWidth + "px";
        this.cardContainer.style.margin = "0";
        this.cardContainer.style.marginLeft = "auto";
        this.cardContainer.style.backgroundSize = "100% auto";
        this.cardContainer.id = "agi-expressions-card-container";
      }
    }, {
      key: "showLoader",
      value: function showLoader() {
        this.config.loader.style.display = "block";
      }
    }, {
      key: "hideLoader",
      value: function hideLoader() {
        this.config.loader.style.display = "none";
      }
    }, {
      key: "selectionData",
      get: function get() {
        return this.productData.selectionData;
      }
    }, {
      key: "send",
      value: function send() {
        var backgroundURL = "url('" + this.config.assetPath + "img/menu_screen.jpg') no-repeat";
        var cardControls = this.addCardControls();
        var buttons = this.addButtons();
        this.loader = this.addLoader();
        this.loader.style.display = "none";
        this.cardContainer.style.background = backgroundURL;
        this.cardContainer.appendChild(cardControls);
        this.cardContainer.appendChild(buttons);
        this.cardContainer.appendChild(this.loader);
        this.config.container.appendChild(this.cardContainer);
        this.setupDefaultJWPlayer();
        this.resize();
      }
    }, {
      key: "pickup",
      value: function pickup() {
        if (this.pers["playlist_url"] !== undefined && this.pers["vtt_url"] !== undefined) {
          this.setupDefaultJWPlayer();
          this.playVideo();
        } else {
          console.warn("Expression Product Error: Personalization not found.");
        }
      }
    }, {
      key: "wireListeners",
      value: function wireListeners() {
        window.addEventListener("resize", this.resize.bind(this));
      }
    }, {
      key: "addCardControls",
      value: function addCardControls() {
        var cardControls = document.createElement("div");
        cardControls.id = "card-controls";
        cardControls.style.textAlign = "left";
        cardControls.style.marginLeft = this.config.controlsMarginLeft;
        cardControls.style.paddingTop = this.config.controlsPaddingTop; //TODO: make a CSS file that loads in with these

        var dropdowns = document.createElement("ol");
        dropdowns.id = "smashup-options";
        dropdowns.style.listStyle = "none";
        dropdowns.style.margin = this.config.dropdownsMargin;
        dropdowns.style.padding = this.config.dropdownsPadding;
        var d = this.productData.dropdowns;

        for (var i = 0; i < this.productData.dropdowns.length; i++) {
          var dropdown = this.productData.dropdowns[i];

          if (!Object.keys(this.config.hardcodedSelections).includes(dropdown.key)) {
            dropdowns.appendChild(this.createDropdown(dropdown));
          }
        }

        cardControls.appendChild(dropdowns);
        return cardControls;
      }
    }, {
      key: "createDropdown",
      value: function createDropdown(data) {
        var container = document.createElement("li");
        container.style.margin = this.config.containerMargin;
        var dropdown = document.createElement("select");
        dropdown.name = data.persName;
        dropdown.className = "select";
        dropdown.style.width = "50%";
        dropdown.style.margin = "0";
        dropdown.style.padding = "0";
        dropdown.style.fontSize = this.config.dropdownsFontsize;
        var defaultItem = document.createElement("option");
        defaultItem.innerHTML = data.label;
        defaultItem.selected = "false";
        defaultItem.value = "default";
        dropdown.appendChild(defaultItem);
        var items = this.productData.selectionData[data.key];
        var lengthOfItems = items.length;

        for (var i = 0; i < lengthOfItems; i++) {
          var item = document.createElement("option");
          item.innerHTML = items[i].value;
          item.value = items[i].id;

          if (item.value == "") {
            item.disabled = "disabled";
          }

          dropdown.appendChild(item);
        }

        dropdown.addEventListener("change", this.selectionChangedHandler.bind(this));
        container.appendChild(dropdown);
        return container;
      }
    }, {
      key: "addButtons",
      value: function addButtons() {
        var buttonRow = document.createElement("div");
        buttonRow.id = "buttonRow";
        buttonRow.style.position = "absolute";
        buttonRow.style.top = this.config.buttonRowTop;
        buttonRow.style.left = this.config.buttonRowLeft;
        var previewButton = document.createElement("a");
        previewButton.style.background = "url('" + this.config.assetPath + "img/product-preview.png') no-repeat";
        previewButton.id = "gv-preview";
        previewButton.href = "#";
        previewButton.style.display = "inline-block";
        previewButton.style.height = this.config.previewButtonHeight;
        previewButton.style.width = this.config.previewButtonWidth;
        previewButton.style.backgroundSize = "100% auto";
        previewButton.addEventListener("click", this.previewButtonClickHandler.bind(this));
        buttonRow.appendChild(previewButton);
        this.previewButton = previewButton;
        var sendButton = document.createElement("a");
        sendButton.style.background = "url('" + this.config.assetPath + "img/product-send.png') no-repeat";
        sendButton.id = "gv-send";
        sendButton.href = "#";
        sendButton.style.display = "inline-block";
        sendButton.style.height = this.config.sendButtonHeight;
        sendButton.style.width = this.config.sendButtonWidth;
        sendButton.style.backgroundSize = "100% auto";
        sendButton.style.marginLeft = "5px";
        sendButton.style.opacity = ".5"; //Added for BMA to hide the product send button if not signed in.

        if (this.config.sitegroup === "bma" && !this.config.maySend) {
          sendButton.style.display = "none";
        }

        buttonRow.appendChild(sendButton);
        this.sendButton = sendButton;
        this.sendButtonClickBind = this.getSendPlaylist.bind(this);
        return buttonRow;
      }
    }, {
      key: "addLoader",
      value: function addLoader() {
        var loaderDiv = document.createElement("div");
        loaderDiv.id = "playlist-loader";
        loaderDiv.style.width = this.originalWidth + "px";
        loaderDiv.style.height = this.originalHeight + "px";
        loaderDiv.style.background = "rgba(192,192,192,0.8)";
        loaderDiv.style.position = "absolute";
        loaderDiv.style.top = "0px";
        loaderDiv.style.left = "0px";
        loaderDiv.style.textAlign = "center";
        var loadingText = document.createElement("p");
        loadingText.innerHTML = "Loading...";
        loadingText.style.margin = "200px auto";
        loadingText.style.fontSize = "40px";
        loadingText.style.color = "white";
        loadingText.style.textShadow = "2px 2px black";
        loadingText.style.textAlign = "center";
        loaderDiv.appendChild(loadingText);
        return loaderDiv;
      }
    }, {
      key: "setupDefaultJWPlayer",
      value: function setupDefaultJWPlayer() {
        this.jwPlayerContainer = document.createElement("div");
        this.jwPlayerWrapper = document.createElement("div");
        this.jwPlayerContainer.style.display = "none";
        this.jwPlayerContainer.id = "jwPlayerContainer";
        this.jwPlayerWrapper.id = "jwPlayerWrapper";
        this.jwPlayerContainer.appendChild(this.jwPlayerWrapper);
        this.config.container.appendChild(this.jwPlayerContainer);
        jwplayer.key = "gtFewPsBNb3uhA6CgFqgrWaicDKqIzAo8X0I/CB7DPCwlLdn";
      }
    }, {
      key: "playVideo",
      value: function playVideo() {
        if (this.jwPlayerContainer) {
          this.jwPlayerContainer.style.display = "block";
        }

        this.createPlaylist();

        if (!this.setupJWPlayer) {
          jwplayer(this.jwPlayerWrapper).setup({
            playlist: this.playlist,
            androidhls: true,
            primary: "html5",
            hlshtml: true,
            debug: true,
            width: parseInt(this.config.container.style.width),
            height: parseInt(this.config.container.style.height)
          }).on("complete", this.closeButtonClickHandler.bind(this)).on("ready", this.playerReady.bind(this));
        } else {
          jwplayer(this.jwPlayerWrapper).load(this.playlist);
        }
      }
    }, {
      key: "createPlaylist",
      value: function createPlaylist() {
        var tracks = [{
          file: location.protocol + this.pers["vtt_url"],
          label: "English",
          kind: "captions",
          "default": this.config.vttOnByDefault
        }];
        this.playlist = [{
          image: this.config.assetPath + "img/poster.jpg",
          file: location.protocol + this.pers["playlist_url"]
        }];

        if (this.config.hasVTT) {
          this.playlist[0].tracks = tracks;
        }
      }
    }, {
      key: "goFullscreen",
      value: function goFullscreen() {
        //Check to see if already in fullscreen
        if (this.isFullscreen) return; //Turn off scrollbars on the page

        document.body.style.overflow = "hidden"; //Initialize wrapper

        this.config.container.style.background = "#000000";
        this.config.container.style.top = "0px";
        this.config.container.style.left = "0px";
        this.config.container.style.width = window.innerWidth + "px";
        this.config.container.style.height = window.innerHeight + "px";
        this.config.container.style.zIndex = "200";
        this.config.container.style.backgroundColor = "#FFFFFF";
        this.config.container.style.position = "fixed";
        this.addCloseButton();
        this.isFullscreen = true;
        this.resize();
      }
    }, {
      key: "addCloseButton",
      value: function addCloseButton() {
        //Add Close Button
        this.closeButton = document.createElement("img");
        this.config.container.appendChild(this.closeButton);
        this.closeButton.id = "expression-close-button";
        this.closeButton.src = this.config.assetPath + "img/close_skip.png";
        this.closeButton.setAttribute("style", "width: initial !important");
        this.closeButton.style.position = "absolute";
        this.closeButton.style.cursor = "pointer";
        this.closeButton.style.display = "block";
        this.closeButton.addEventListener("click", this.closeButtonClickHandler.bind(this));
        this.closeButton.style.top = "0%";
        this.closeButton.style.right = "0%"; //This is to bugfix awful importants in base css on AG

        var currentCssText = this.closeButton.style.cssText;
        this.closeButton.style.cssText = currentCssText + " width:137px !important; height:37px !important;";
      }
    }, {
      key: "isReadyToPlay",
      value: function isReadyToPlay() {
        var numberOfPersonalizationsChosen = 0;

        for (var i = 0; i < this.productData.dropdowns.length; i++) {
          var dropdown = this.productData.dropdowns[i];
          var persKey = dropdown.persName;

          if (this.selections[persKey] !== undefined) {
            numberOfPersonalizationsChosen++;
          } else {
            break;
          }
        }

        return numberOfPersonalizationsChosen === this.productData.dropdowns.length;
      }
    }, {
      key: "selectionChangedHandler",
      value: function selectionChangedHandler(event) {
        var persField = event.target.name;

        if (event.target.value !== "default") {
          this.selections[persField] = event.target.value;
        } else {
          this.selections[persField] = undefined;
        }

        if (this.isReadyToPlay()) {
          this.sendButton.style.opacity = "1";
          this.sendButton.addEventListener("click", this.sendButtonClickBind);
        } else {
          this.sendButton.style.opacity = "0.5";
          this.sendButton.removeEventListener("click", this.sendButtonClickBind);
        }
      }
    }, {
      key: "previewButtonClickHandler",
      value: function previewButtonClickHandler(event) {
        event.preventDefault();

        if (this.isReadyToPlay()) {
          this.getPreviewPlaylist();
        }
      }
    }, {
      key: "closeButtonClickHandler",
      value: function closeButtonClickHandler(event) {
        if (this.isFullscreen !== true) {
          return;
        }

        if (this.previewButton) {
          this.previewButton.style.opacity = "1.0";
        }

        this.config.container.style.position = "relative";
        this.config.container.style.zIndex = "auto"; //Turn Scrollbars On

        document.body.style.overflow = "visible";
        this.isFullscreen = false;
        if (this.closeButton !== undefined) this.config.container.removeChild(this.closeButton);

        if (this.config.mode === "init") {
          try {
            var backgroundURL = "url('" + this.config.assetPath + "img/menu_screen.jpg') no-repeat";
            this.config.container.style.background = backgroundURL;
            this.config.container.style.backgroundSize = "100% auto";
            jwplayer(this.jwPlayerWrapper).remove();
          } catch (error) {
            //The player refused to remove itself so we will do it visually.
            this.jwPlayerContainer.style.display = "none";
          }

          this.cardContainer.style.display = "block";
        } else {
          var currentPosition = jwplayer(this.jwPlayerWrapper).getPosition();
          var duration = jwplayer(this.jwPlayerWrapper).getDuration();

          if (duration > 0 && Math.floor(duration) !== Math.floor(currentPosition)) {
            jwplayer(this.jwPlayerWrapper).stop();
          }
        }

        this.resize();
      }
    }, {
      key: "playerReady",
      value: function playerReady(event) {
        if (this.isFullscreenOnPlayDisabled) {
          this.resize();
        } else {
          this.goFullscreen();
        }

        var video = document.getElementsByTagName("video");

        if (video.length > 0) {
          video = video[0];
          video.addEventListener("webkitendfullscreen", this.closeButtonClickHandler);
        }
      }
    }, {
      key: "resize",
      value: function resize(event) {
        var container = this.config.container;

        if (this.isFullscreen) {
          this.fullscreenResize(container);
        } else {
          this.defaultResize(container);
        }
      }
    }, {
      key: "fullscreenResize",
      value: function fullscreenResize(container) {
        container.style.width = window.innerWidth + "px";
        container.style.height = window.innerHeight + "px";

        if (container.parentNode !== null) {
          container.parentNode.style.width = "";
          container.parentNode.style.height = "";
        }

        jwplayer(this.jwPlayerWrapper).resize(window.innerWidth, window.innerHeight);
        window.scroll(0, 1);
      }
    }, {
      key: "getPreviewPlaylist",
      value: function getPreviewPlaylist() {
        var url = location.protocol + this.config.generatePlaylistURL;
        var data = {
          pn: this.config.videoProductNumber,
          choices: this.selections
        };
        var playlistLoader = new PlaylistLoader().load(url, data).then(this.previewPlaylistLoadedHandler.bind(this))["catch"](this.playlistErrorHandler.bind(this));
        this.loader.style.display = "block";
      }
    }, {
      key: "getSendPlaylist",
      value: function getSendPlaylist(event) {
        if (this.config.maySend) {
          var url = this.config.generatePlaylistURL;
          var data = {
            pn: this.config.videoProductNumber,
            choices: this.selections
          };
          var loader = new PlaylistLoader().load(url, data).then(this.sendPlaylistLoadedHandler.bind(this, event))["catch"](this.playlistErrorHandler.bind(this));
          this.loader.style.display = "block";
        } else {
          alert("Please sign in to send this card.");
        }
      }
    }, {
      key: "previewPlaylistLoadedHandler",
      value: function previewPlaylistLoadedHandler(data) {
        if (data != null) {
          this.pers = data;
          this.loader.style.display = "none";
          this.cardContainer.style.display = "none";
          this.playVideo();
        }
      }
    }, {
      key: "sendPlaylistLoadedHandler",
      value: function sendPlaylistLoadedHandler(event, data) {
        if (data != null) {
          this.pers = data;
          this.config.sendButtonClickHandler(event);
        }
      }
    }, {
      key: "playlistErrorHandler",
      value: function playlistErrorHandler(error) {
        // TODO: get requirements for error handling
        console.error("Could not load video:", error);
        this.loader.style.display = "none";
      }
    }, {
      key: "defaultResize",
      value: function defaultResize(container) {
        var innerHeightAdjustment = 0.95; //Add some padding for landscape
        var containerSize = this.originalWidth;

        if (container.parentNode !== null) {
          container.parentNode.style.width = "100%";
          container.parentNode.style.height = "100%";
        }

        if (window.innerHeight < containerSize) {
          containerSize = window.innerHeight * innerHeightAdjustment;
        } else if (container.parentNode !== null) {
          if (container.parentNode.offsetWidth < containerSize) {
            containerSize = container.parentNode.offsetWidth;
          }
        }

        if (containerSize > this.originalWidth) {
          var scale = 1;
        } else {
          var scale = containerSize / this.originalWidth;
        }

        this.setScale(container, container.parentNode, scale);
      }
    }, {
      key: "setScale",
      value: function setScale(container, parent, scale) {
        this.cardContainer.style.transformOrigin = "top left";
        this.cardContainer.style.webkitTransformOrigin = "top left";
        this.cardContainer.style.transform = "scale(" + scale + "," + scale + ")";
        this.cardContainer.style.webkitTransform = "scale(" + scale + "," + scale + ")";
        container.style.width = "".concat(this.originalWidth * scale, "px");
        container.style.height = "".concat(this.originalHeight * scale, "px");
        var player = jwplayer(this.jwPlayerWrapper);

        if (player !== undefined && player.getDuration() !== undefined) {
          player.resize(this.originalWidth * scale, this.originalHeight * scale);
        }

        if (parent !== null) {
          parent.style.width = container.style.width;
          parent.style.height = container.style.height;
          parent.style.margin = "0 auto";
        }
      }
    }]);

    return VideoPlayer;
  }();

  var VideoPlayerFactory = /*#__PURE__*/function () {
    function VideoPlayerFactory(config) {
      _classCallCheck(this, VideoPlayerFactory);

      this.config = config || {};
    }

    _createClass(VideoPlayerFactory, [{
      key: "create",
      value: function create() {
        var _this = this;

        var url = this.config["selectionDataURL"];

        if (url == null) {
          return new Promise(function (resolve, reject) {
            resolve(_this.createVideoPlayer());
          });
        } else {
          return this.requestSelectionData(url);
        }
      }
    }, {
      key: "requestSelectionData",
      value: function requestSelectionData(url) {
        return fetch(url, {
          method: "GET",
          mode: "cors"
        }).then(function (response) {
          return response.json();
        }).then(this.updateSelectionData.bind(this))["catch"](this.createVideoPlayer.bind(this));
      }
    }, {
      key: "updateSelectionData",
      value: function updateSelectionData(data) {
        this.config["selectionData"] = data;
        return this.createVideoPlayer();
      }
    }, {
      key: "createVideoPlayer",
      value: function createVideoPlayer() {
        return new VideoPlayer(this.config);
      }
    }]);

    return VideoPlayerFactory;
  }();

  exports.PlaylistLoader = PlaylistLoader;
  exports.ProductData = ProductData;
  exports.VideoPlayer = VideoPlayer;
  exports.VideoPlayerFactory = VideoPlayerFactory;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
